<template>
<div>
<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>
<div class="mt-4" v-if="!loading" style="min-height:450px">
<div class="grid">







<DataTable :value="thenonconformities"  
  class="p-datatable-sm w-full" 
  stripedRows
  editMode="cell"
  @cell-edit-complete="onCellEditComplete" 
  tableClass="editable-cells-table"
  paginator :rows="10" :rowsPerPageOptions="[5, 10, 20, 50]"
  sortMode="multiple"
  >

<Column field="inputfield.name" :header="$store.state.languages.lang_phrases.soru" style="width: 45%">
  <template #body="slotProps">
    <p class="editable_input" @click="showMe(slotProps.data.inputfield)">

      <template v-if="slotProps.data.inputfield.translations.length">
        <router-link   class="text-primary p-link no-underline" :to="{ name: 'AuditActionPlanItem' , params: { nonconformity_id: slotProps.data.id }}">{{getTheTranslation(slotProps.data.inputfield,"translation")}}</router-link>
      </template>

      <template v-else>
        <router-link   class="text-primary p-link no-underline" :to="{ name: 'AuditActionPlanItem' , params: { nonconformity_id: slotProps.data.id }}">{{slotProps.data.inputfield.name}}</router-link>        
      </template>

    
      
    </p>
    
  </template>

</Column>

<Column field="submission.submission_note" :header="$store.state.languages.lang_phrases.denetim_bulgusu" style="width: 35%">
  <template #body="slotProps">
    <p class="editable_input">
    {{slotProps.data.inputfield.submissions[0].submission_note}}
    </p>
    
  </template>
</Column>

<Column field="submission" :header="$store.state.languages.lang_phrases.uygunsuzluk_tipi">
  <template #body="slotProps">

    

    <Tag 
    class="mr-2 mt-1 custom-chip" 
    :value="slotProps.data.nonconformitytype.name" 
    :style="'background-color:'+getNonconformitytypeData(slotProps.data)"
    />
    
  </template>
</Column>


<Column field="submission" :header="$store.state.languages.lang_phrases.durum">
  <template #body="slotProps">

    <Tag 
    class="mr-2 mt-1 custom-chip" 
    :value="this.$store.state.languages.lang_phrases[getSubmissionStatus(slotProps.data).title]" 
    :style="'background-color:'+getSubmissionStatus(slotProps.data).color"
    />
    
  </template>
</Column>











</DataTable>


</div>

</div>
</div>
</template>

<script>
export default {

  name: 'AuditActionPlan',

  data () {
    return {
      loading:true,
      thenonconformities:[],
      nonconformity_types:[],
      columns:[  
      {
        type:"text",
        field:"inputfield_name", 
        header:"soru",      
        with_route:true,
        hide_on_mobile:false,
      }, 
      {
        type:"pill",
        field:"status", 
        header:"durum",       
        options:[
          {
            name:"pending",
            color:"#a855f7",
            text:"degerlendirmede",
          },
          {
            name:"rejected",
            color:"#dd4b39",
            text:"reddedildi",
          },
          {
            name:"approved",
            color:"#4dc247",
            text:"tamamlandi",
          },
          {
            name:"open",
            color:"#ff6600",
            text:"beklemede",
          },
        ],
      },
      ],
    }
  },
  mounted()
  {
    this.$store.dispatch('ui/setActiveTab',"aksiyon_plani") 
    this.getData()
  },
  methods:{
    showMe(data)
    {
      console.log(data)
    },

    prepareNonconformity(nonconformity)
    {
      
      let obj = nonconformity.inputfield
      obj.completion = true
      obj.show_evidence_btn = false
      obj.show_info_textarea = false
      obj.read_only_state = true
      nonconformity.nonconformity_type_name = "adsfdf"
      
      nonconformity.inputfield = obj
      nonconformity.inputfield_name = nonconformity.inputfield.name
      if(nonconformity.lastclosurerequest)
      {
        if(nonconformity.lastclosurerequest.status=="pending")
        {
          nonconformity.status = "pending"
        }
        if(nonconformity.lastclosurerequest.status=="rejected")
        {
          nonconformity.status = "rejected"
        }

        if(nonconformity.lastclosurerequest.status=="approved")
        {
          nonconformity.status = "approved"
        }
      }
      let type = this.nonconformity_types.find((item)=>{return item.id == nonconformity.nonconformitytype_id})
      
      if(type)
      {
        console.log("nonconformity_types")
        console.log(type.name)
        nonconformity.nonconformity_type_name = type.name
      }
      else
      {
        nonconformity.nonconformity_type_name = "dfdfdf"
      }


      return nonconformity
    },


    getNonconformitytypeData(item)
    {
      let color = "rgb(221, 75, 57)"
      if(item.nonconformitytype && item.nonconformitytype.color)
      {
        color = item.nonconformitytype.color
      
      }

      return color
    },

    getSubmissionStatus(item)
    {
      let element = {
        title:"beklemede",
        color:"#352f8d"
      }
      if(item.status=="open")
      {
        return {
            color:"#ff6600",
            title:"beklemede"
          }
      }
      if(item.lastclosurerequest)
      {
        if(item.lastclosurerequest.status=="pending")
        {
          element.title = "degerlendirmede"
          element.color = "#352f8d"
        }
        if(item.lastclosurerequest.status=="rejected")
        {
          element.title = "reddedildi"
          element.color = "#dd4b39"
        }

        if(item.lastclosurerequest.status=="approved")
        {
          element.title = "tamamlandi"
          element.color = "#4dc247"
        }
      }
      return element
    },
    getSubmissionVal(item)
    {
      console.log(item)
      let submission = item.submission.submission_option
      let options = item.questionlist.options
      let option = options.find((element)=>{return element.id == submission})
      if(option)
      {
        if(option.color)
        {
          return {
            color:option.color,
            name:option.name
          }
        }
        else
        {
          return {
            color:"#352f8d",
            name:option.name
          }
        }
        
      }
      return {
        color:"#352f8d",
        name:""
      }
      
    },
    async getData()
    {
      console.log(this.$store.state.audit.audit)      
      this.loading = true

      let data = await this.generalApiGetWithoutLoader("get_audit_nonconformities/"+this.$store.state.audit.audit.uuid) 
      console.log(data)
      for(let item of data.nonconformities)
      {
        this.thenonconformities.push(this.prepareNonconformity(item))
      }
      this.nonconformity_types = data.nonconformity_types
      this.loading = false
    },
    onCellEditComplete(event)
    {
      console.log(event)
      let formdata = new FormData()
      formdata.append("supplier_submission",event.newData.supplier_submission)
      formdata.append("auditor_submission",event.newData.auditor_submission)
      formdata.append("controller_submission",event.newData.controller_submission)
      this.generalSubmission(formdata,"update_audit_nonconformities/"+event.newData.id,this.afterdataChanged)
    },
    afterdataChanged(response)
    {
      let ind = this.actionplans.findIndex((item)=>{return item.id == response.data.id})
      console.log(response.data)
      console.log(ind)
      this.actionplans[ind] = response.data
    }
  }
}
</script>

<style lang="css" scoped>
</style>